import React from 'react'
import Input from 'Components/Input'
import Switch from 'Components/Switch'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getConfiguration()
    }
  }

  getConfiguration = async () => {
    const result = await ApiRequest(project.api + 'messagerie', {
      requete: 'configuration',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle,
        type_messagerie_id: result.results.type_messagerie_id,
        libelle: result.results.libelle,
        privee: result.results.privee,
        information_complementaire: JSON.parse(result.results.information_complementaire),
        information_complementaire_form: JSON.parse(Data.get(Constants.module.MESSAGERIE, Constants.donnee.type_messagerie, { id: result.results.type_messagerie_id }).information_complementaire),
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onChangeInformationComplementaire = (e, name) => {
    this.setState({
      information_complementaire: {
        ...this.state.information_complementaire,
        [name]: e
      }
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      type_messagerie_id: undefined,
      libelle: '',
      privee: false,
      information_complementaire: [],
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'messagerie', {
      requete: 'configuration',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      type_messagerie_id: this.state.type_messagerie_id,
      libelle: this.state.libelle,
      privee: this.state.privee,
      information_complementaire: this.state.information_complementaire,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onChangeTypeMessagerie = (value, name) => {
    this.setState({
      information_complementaire_form: value && JSON.parse(Data.get(Constants.module.MESSAGERIE, Constants.donnee.type_messagerie, { id: value }).information_complementaire) || []
    }, () => this.onChangeState(value, name))
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'messagerie', {
      requete: 'configuration',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <form autoComplete={'off'}>
        <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
              justify="flex-start"
              alignItems="stretch">
          <DataComponent
            onChange={this.onChangeTypeMessagerie}
            title={EurestoI18n.t('crm:Type Messagerie')}
            name={'type_messagerie_id'}
            disabled={disabled}
            type={Constants.typeSaisie.ComboSimple}

            data={this.state.type_messagerie_id}
            module={Constants.module.MESSAGERIE}
            object={Constants.donnee.type_messagerie}
          />
          <Input
            key={autoFocus}
            autoFocus={autoFocus}
            title={EurestoI18n.t('commun:Messagerie')}
            onChange={this.onChangeState}
            name={'libelle'}
            disabled={disabled}
            value={this.state.libelle}
            type="text"
          />
          {
            (this.state.information_complementaire_form || []).map((info, i) => {
              return <DataComponent
                onChange={this.onChangeInformationComplementaire}
                title={info.title}
                name={info.title}
                type={info.type}
                disabled={disabled}
                data={this.state.information_complementaire && this.state.information_complementaire[info.title]}
                defineData={true}
                inputType={info.input}
              />
            })
          }
          <Switch onChange={this.onChangeState}
                  name="privee"
                  disabled={disabled}
                  checked={this.state.privee}
                  label={EurestoI18n.t('crm:Privée')}/>
        </Grid>
      </form>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvelle messagerie')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Messagerie/Configuration.js